import OrdertNotes from './OrderNotes.vue';

export default OrdertNotes;
